import { useCallback, useMemo, useState } from "react";

import { Box } from "@mui/material";
import { size } from "lodash";
import { useDispatch } from "react-redux";
import { sidebarOpen } from "../../../redux/reducers/sidebarReducer";
import Flx from "../../layout/Flx";
import { DASHBOARD_SIDEBAR_TYPES } from "../../sidebars/DashboardSidebar/DashboardSidebar";
import LoanConditionsTable from "../../tables/LoanConditionsTable";
import Txt from "../../typography/Txt";
import FilterTabSwitcher from "../../../_src_shared/components/navigation/FilterTabSwitcher";
const TAB_TYPES = {
  ALL: "ALL",
  DOCUMENTS: "DOCUMENTS",
  CONDITIONS: "CONDITIONS",
};
const FinancingRequestConditionsTab = ({ loanId, conditions = [] }) => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState("All");

  const tabs = useMemo(() => buildStatusFilterTabs(conditions), [conditions]);
  const filteredConditions = useMemo(() => {
    if (tab === "All") {
      return conditions;
    }
    return conditions.filter((c) => c.status === tab);
  }, [tab, conditions]);

  const onRowClicked = useCallback((params) => {
    dispatch(
      sidebarOpen(DASHBOARD_SIDEBAR_TYPES.UPDATE_LOAN_CONDITION, params?.data, {
        loanId,
        conditionId: params.data._id,
      }),
    );
  }, []);

  if (!conditions || conditions.length === 0) {
    return (
      <Flx column center sx={{ p: 4, gap: 2 }}>
        <Txt secondary center>
          No Conditions Found
        </Txt>
      </Flx>
    );
  }

  return (
    <Box sx={{ height: "100%" }}>
      <Flx g={1} fw jb ac wrap sx={{ mb: 2 }}>
        <Flx g={0.2} column>
          <Txt bold>Loan Conditions ({size(conditions)})</Txt>
          <Txt secondary>
            Review and address outstanding conditions, stips, and document
            requirements to move the loan forward.
          </Txt>
        </Flx>
        <FilterTabSwitcher
          value={tab}
          fontSize={11}
          onChange={setTab}
          tabs={tabs}
        />
      </Flx>
      <LoanConditionsTable
        rowData={filteredConditions}
        onRowClicked={onRowClicked}
      />
    </Box>
  );
};
const buildStatusFilterTabs = (conditions = []) => {
  const counts = {};
  conditions.forEach((c) => {
    const status = c.status || "Unknown";
    counts[status] = (counts[status] || 0) + 1;
  });

  const tabs = [{ label: "All", value: "All", count: conditions.length }];
  Object.entries(counts).forEach(([status, count]) => {
    tabs.push({ label: status, value: status, count });
  });

  return tabs;
};

export default FinancingRequestConditionsTab;
